import React from 'react'
import { useFormik } from 'formik';

import styled from 'styled-components'
import { COLORS } from '../constants/colors'
import { device } from '../constants/device';

import KontaktTallinn from '../images/svg/kontaktid_tallinn.svg'
import KontaktTartu from '../images/svg/kontaktid_tartu.svg'


//Styles

const PageBackgroundContainer = styled.div`
height: 100%;
width: 100%;
background-color: ${COLORS.primary};
`

const PageContainer = styled.div`
max-width: 1200px;
width: 90%;
margin: auto;
padding-top: 5rem;
display: grid;
grid-template-columns: 1fr;
color: ${COLORS.black};
font-family: Arial, Helvetica, sans-serif;
font-size: 1rem;
font-weight: 400;
text-align: left;
line-height: 2rem;

 @media ${device.laptop} {
   grid-template-columns: 1fr 1fr;
   grid-gap: 3rem;
   padding-top: 10rem;
  }
`

const Kauplustest = styled.div`

  @media ${device.laptop} {
  grid-column-start: 1;
  grid-column-end: 2;
  //grid-row-start: 1;
  //grid-row-end: 3;
  }
`

const JuriidilineJaKiri = styled.div`

  @media ${device.laptop} {
  grid-column-start: 2;
  grid-column-end: 3;
  }
`


const FormContainer = styled.form`
display: grid;
grid-template-columns:1fr;
width:100%;
`

// form 
const Label = styled.label`
 font-weight: 600;
  font-size: 0.8rem;
  display: flex;
`

const Input = styled.input`
width: 100%;
margin: auto;
padding: 0.65rem 0;
font-size: 0.8rem;
border: solid 1px ${COLORS.primary};
background-color: ${COLORS.white};
color: ${COLORS.black};
-webkit-appearance: none;
-moz-appearance: none;
appearance: none;

  &:focus {
  outline: none;
  border: 1px solid ${COLORS.secondary};
}
&:invalid {
  border: 2px solid ${COLORS.red};
  box-shadow: none;
}
`

const Textarea = styled.textarea`
width: 100%;
margin: auto;
-webkit-appearance: none;
-moz-appearance: none;
appearance: none;
font-size: 1rem;
border: solid 1px ${COLORS.primary};
background-color: ${COLORS.white};
color: ${COLORS.black};
resize: vertical;
box-sizing: border-box;
padding: 0.65rem 0.5rem;
font-family: -apple-system, BlinkMacSystemFont, "avenir next", avenir,
    "helvetica neue", helvetica, ubuntu, roboto, noto, "segoe ui", arial,
    sans-serif;
`


const Checkbox = styled.input` 
border: 1px solid ${COLORS.gray};
width: 1rem;
margin-right: 0.5rem;

  &:hover {
  cursor: pointer;
}

&:checked {
border: 1px solid ${COLORS.third};
}
`

const Button = styled.button`
padding: 1rem 1.25rem;
font-size: 1rem;  
background-color: ${COLORS.third};
color: ${COLORS.white};
border:none;
text-decoration: none;
font-weight: bold;
margin-bottom: 3rem;
cursor: pointer;

&:disabled {
background-color: ${COLORS.secondary};
color: ${COLORS.white};
cursor: not-allowed;
}
`

const Error = styled.div`
 font-size: 12px;
  color: ${COLORS.error};
  margin-top: 0.25rem;
`

const SVG = styled.img`
 width: 100%;
 margin: auto;
 padding-bottom: 1rem;
 transition: fill 0.25s;

 margin-top:0.5rem;
 margin-bottom: 0.5rem;
   @media ${device.laptop} {
 margin-top:0;
 margin-bottom: 0.5rem;
  }
`

const Pealkiri = styled.h1`
font-size: 2em;
font-weight: 500;
text-align: left;
color:${COLORS.black};
font-family: 'Times New Roman', Times, serif;
text-transform: capitalize;
font-style: italic;
  padding-top: 1rem;
  margin:0;
  padding-bottom:0.2em;

   @media ${device.laptop} {
    padding-top: 3rem;
    font-size: 3em;
  }
`

const AlaPealkiri = styled.h2`
font-size: 1rem;
font-weight: 600;
text-align: left;
color:${COLORS.black};
font-family: Arial, Helvetica, sans-serif;
text-transform: uppercase;
margin:1rem 0 0.3rem 0;
margin-top:3rem;
`

const Tekst = styled.p`
font-size: 0.8rem;
font-weight: 500;
margin: 0.2rem;
line-height: 1.3rem;
`

const Pank = styled.span`
font-size: 0.8rem;
font-weight: 600;
`

const DivSisuKahesReas = styled.div`

display: grid;
grid-template-columns:1fr;
column-gap: 2rem;
width:100%;

  @media ${device.tablet} {
grid-template-columns:1fr 1fr;
  }
`

const validate = values => {
  const errors = {};

  if (!values.nimi) {
    errors.nimi = 'Kohustuslik väli';
  } else if (values.nimi.length > 15) {
    errors.nimi = 'Kuni 15 tähemärki.';
  }

  if (!values.email) {
    errors.email = 'Kohustuslik väli';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Vale e-kirja aadress.';
  }

  if (!values.telefon) {
    errors.telefon = 'Kohustuslik väli';
  } else if (values.telefon.length > 15) {
    errors.telefon = 'Kuni 15 tähemärki.';
  }

  if (!values.kommentaar) {
    errors.kommentaar = 'Kohustuslik väli';
  } else if (values.kommentaar.length > 5000) {
    errors.kommentaar = 'Kuni 5000 tähemärki.';
  }

  if (!values.olenTutvunud) {
    errors.kommentaar = 'Kohustuslik väli';
  }

  return errors;
};


const Kontakt = () => {
  // Pass the useFormik() hook initial form values and a submit function that will
  // be called when the form is submitted
  const formik = useFormik({
    initialValues: {
      nimi: '',
      ettevõte: '',
      email: '',
      telefon: '',
      kommentaar: '',
      olenTutvunud: false
    },
    validate,
  });


  return (
    <PageBackgroundContainer>
      <PageContainer>
        <Kauplustest>
          <Pealkiri>Lukupood OÜ</Pealkiri>
          <Tekst>Reg. nr.	10009634 | KMKR nr. EE100289394</Tekst>
          <br />

          <AlaPealkiri>Klienditugi:</AlaPealkiri>
          <Tekst><a href="mailto:info@ukselingid.ee">info@ukselingid.ee</a> | <a href="tel:+372 5858 2240">+372 5858 2240</a></Tekst>
          <br />

          <AlaPealkiri>KAUPLUSED:</AlaPealkiri>
          <Tekst>Peterburi tee 34, 11415 Tallinn | E-R 9-18<br />
            Narva mnt 27b, 51009 Tartu | E-R 9-18, L 11-15<br />
            Riia 142, 50411 Tartu | E-R 9-18</Tekst>
        </Kauplustest>

        <SVG src={KontaktTallinn} alt='Tallinna pood' />
        <SVG src={KontaktTartu} alt='Tartu poed' />

        <JuriidilineJaKiri>
          <DivSisuKahesReas>
            <div>
              <AlaPealkiri>JURIIDILINE AADRESS:</AlaPealkiri>
              <Tekst>Narva mnt 27b<br />
                51009, Tartu<br />
                Eesti</Tekst>
            </div>
            <div>
              <AlaPealkiri>PANGARETVISIIDID:</AlaPealkiri>
              <Tekst><Pank>Swedbank </Pank>IBAN: EE212200001120115269<br />
                <Pank>SEB Pank </Pank>IBAN: EE651010220032188016<br />
                <Pank>LHV Pank </Pank>IBAN: EE667700771000802621</Tekst>
            </div>
          </DivSisuKahesReas>

          <AlaPealkiri>KUIDAS SAAME TEID AIDATA?</AlaPealkiri>
          <FormContainer
            name="kontakt"
            method="post"
            action="/kiri-saadetud/"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
          >

            {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
            <input type="hidden" name="form-name" value="kontakt" />
            <div hidden>
              <label>
                Don’t fill this out:{' '}
                <input
                  name="bot-field"
                />
              </label>
            </div>

            <div>
              <Label htmlFor="nimi">Nimi*</Label>
              <Input
                id="nimi"
                name="nimi"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.nimi}
                onBlur={formik.handleBlur}
              />
              {formik.touched.nimi && formik.errors.nimi ? <Error>{formik.errors.nimi}</Error> : null}
            </div>

            <DivSisuKahesReas>
              <div>
                <Label htmlFor="email">E-kiri*:</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  onChange={formik.handleChange}
                  value={formik.values.email}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email ? <Error>{formik.errors.email}</Error> : null}
              </div>

              <div>
                <Label htmlFor="telefon">Telefon*</Label>
                <Input
                  id="telefon"
                  name="telefon"
                  type="tel"
                  onChange={formik.handleChange}
                  value={formik.values.telefon}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.telefon && formik.errors.telefon ? <Error>{formik.errors.telefon}</Error> : null}
              </div>
            </DivSisuKahesReas>

            <div>
              <Label htmlFor="ettevõte">Ettevõte</Label>
              <Input
                id="ettevõte"
                name="ettevõte"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.ettevõte}
              />
            </div>



            <div>
              <Label htmlFor="kommentaar">Teie sõnum*</Label>
              <Textarea
                id="kommentaar"
                name="kommentaar"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.kommentaar}
              />
            </div>

            <div>
              <Label htmlFor="olenTutvunud">Soovin liituda uudiskirjaga</Label>
              <Checkbox
                id="olenTutvunud"
                name="olenTutvunud"
                type="checkbox"
                onChange={formik.handleChange}
                value={formik.values.olenTutvunud}
              />
            </div>

            <Button type="submit" disabled={!formik.values.kommentaar || !formik.values.telefon || !formik.values.email || !formik.values.nimi}>SAADA SÕNUM</Button>
          </FormContainer>


          {/* <form
            name="tehtudtellimuseandmed"
            method="post"
            action="/tellimus-tehtud/"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
          >

            
          <input type="hidden" name="form-name" value="tehtudtellimuseandmed" />
          <div hidden>
            <label>
              Don’t fill this out:{' '}
              <input
                name="bot-field"
              />
            </label>
          </div>



          <label htmlFor="valitudTrantsport">Valitud trantsport ja tellimuse nr.</label>
          <input
            id="valitudTrantsport"
            name="valitudTrantsport"
            type="text"
            value='tere'
            readonly
          />



          <label htmlFor="tooted">Tellitud tooted</label>
          <input
            id="tooted"
            name="tooted"
            type="text"
            value='tere'
            readonly
          />



          <label htmlFor="summa">Summa</label>
          <input
            id="summa"
            name="summa"
            type="text"
            value='tere'
            readonly
          />




          <div>
            <label htmlFor="nimi">Nimi*</label>
            <input
              id="nimi"
              name="nimi"
              type="text"

              value='tere'

            />

          </div>


          <div>
            <label htmlFor="ettevõte">Ettevõte</label>
            <input
              id="ettevõte"
              name="ettevõte"
              type="text"

              value='tere'
            />
          </div>



          <div>
            <label htmlFor="email">E-post*</label>
            <input
              id="email"
              name="email"
              type="email"

              value='tere@gmail.com'

            />

          </div>

          <div>
            <Label htmlFor="telefon">Telefoni nr.*</Label>
            <Input
              id="telefon"
              name="telefon"
              type="tel"

              value='tere'

            />

          </div>


          <div>
            <label htmlFor="kommentaar">Kommentaar</label>
            <textarea
              id="kommentaar"
              name="kommentaar"
              type="text"

              value='tere'
            />
          </div>


          <div>
            <label htmlFor="olenTutvunud">Olen tutvunud ostutingimustega</label>
            <checkbox
              id="olenTutvunud"
              name="olenTutvunud"
              type="checkbox"

              value='tere'
            />
          </div>

          <button type="submit">VORMISTA TELLIMUS</button>
        </form>*/}



        </JuriidilineJaKiri>
      </PageContainer>
    </PageBackgroundContainer >
  )
}

export default Kontakt
